const _ = require('lodash')
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
      activities: []
    },
    getters: {
      activities: (state, getters, rootState) => _.map(state.activities, activity => {
        const { room_code } = activity
        if(rootState.auth.user.activities) {
          activity.booking = _.find(rootState.auth.user.activities, { room_code })
        }
        const placeVisitor = activity.place_visitor ? activity.place_visitor[0] : null
        activity.placeVisitor = placeVisitor
        activity.hasBeenVisited =  placeVisitor && placeVisitor.checked_at
        return activity
      }),
      bookedActivities: (state, getters) => _.orderBy(
        _.filter(getters.activities, activity => activity.is_booked_activity && !activity.hasBeenVisited),
        ['booking.date', 'booking.time_start'],
        ['asc', 'asc']
      ),
      bookedWithTimeActivities: (state, getters) => _.filter(getters.bookedActivities, activity =>  activity.booking && activity.booking.time_start),
      visitedActivities: (state, getters) => _.filter(getters.activities, activity => activity.hasBeenVisited),
      unbookedActivities: (state, getters) => _.filter(getters.activities, activity =>
        !activity.is_booked_activity && !activity.hasBeenVisited
        /*const { id } = activity
        const { visitedActivities, bookedActivities } = getters
        return !_.find(visitedActivities, { id }) && !_.find(bookedActivities, { id })*/
      )
    },
    actions: {
      fetchActivities: ({ commit, dispatch }) => {
        axios.get('/activities')
          .then(response => {
            commit('setActivities', response.data)
          })
      },
    },
    mutations: {
      setActivities: (state, activities) => {
        state.activities = activities
      },
      changeRating: (state, { id, rating }) => {
        const found = _.find(state.activities, { id })
        found.place_visitor[0].rating = rating
      }
    },

}
